module.exports = __webpack_public_path__ + "static/img/20yuanfengding.404e3b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/20yuanfengding.png
// module id = jZ6T
// module chunks = 1